<template>
  <div class="d d_xm">
    <headers :goBack="goBack" :isForm="1" />
    <div class="title">
      街道社区少工委信息统计
      <div class="tip">（由县级少工委相关同志填写）</div>
    </div>
    <van-form
      @submit="onClickButtonSubmit"
      validate-trigger="onSubmit"
      @failed="handleFailed"
    >
    <div class="kuang">
      <!-- <diy-picker
        title="校外少工委所在地"
        :value="states.schoolOutAreaTxt"
        :list="schoolOutAreaList"
        :handlerSelect="selectSchoolOutArea"
        :isClick="true"
        :isRequired="schoolOutAreaFlag"
      /> -->
      <diy-picker
        title="组织类型"
        :value="states.organizationTypeTxt"
        :list="organizationTypeList"
        :handlerSelect="selectOrganizationType"
        :isClick="true"
        :isRequired="organizationTypeFlag"
      />
      <van-field
        required
        v-model="states.schoolOutSgwName"
        clearable
        label="校外少工委组织名称"
        placeholder="请输入校外少工委组织名称"
        :rules="[{ required: true, message: '请填写校外少工委组织名称' }]"
      />
      <van-field
        required
        v-model="states.schoolOutSgwNameSure"
        clearable
        label="确认校外少工委组织名称"
        placeholder="请确认校外少工委组织名称"
        :rules="[{ required: true, message: '请确校外少工委组织名称' }]"
        :error="schoolOutSgwNameDifferent"
        :error-message="errorMessageSchoolOutSgwName"
        @blur="validateInputsSchoolOutSgwNamee"
        @paste.prevent
      />
      <datetime-picker
        :value="states.foundTime"
        title="成立时间"
        type="year-month"
        :callback="(val) => handlerFoundTimeSelect('foundTime', val)"
        :isRequired="foundTimeFlag"
      />
      <van-field
        required
        v-model="states.sgwZhuRenName"
        clearable
        label="少工委主任姓名"
        placeholder="请输入少工委主任姓名"
        :rules="[{ required: true, message: '请填写少工委主任姓名' }]"
      />
      <van-field
        required
        v-model="states.sgwZhuRenNameSure"
        clearable
        label="确认少工委主任姓名"
        placeholder="请确认少工委主任姓名"
        :rules="[{ required: true, message: '请确少工委主任姓名' }]"
        :error="sgwZhuRenNameDifferent"
        :error-message="errorMessageSgwZhuRenName"
        @blur="validateInputSgwZhuRenName"
        @paste.prevent
      />

      <van-field
        required
        v-model="states.organization"
        clearable
        label="所在单位"
        placeholder="请输入所在单位"
        :rules="[{ required: true, message: '请填写所在单位' }]"
      />
      <van-field
        required
        v-model="states.organizationSure"
        clearable
        label="确认所在单位"
        placeholder="请确认所在单位"
        :rules="[{ required: true, message: '请确所在单位' }]"
        :error="organizationDifferent"
        :error-message="errorMessageOrganization"
        @blur="validateInputOrganization"
        @paste.prevent
      />
      <diy-picker
        title="少工委主任职务"
        :value="states.sgwZhuRenMajorTxt"
        :list="sgwZhuRenMajorList"
        :handlerSelect="selectSgwZhuRenMajor"
        :isClick="true"
        :isRequired="sgwZhuRenMajorFlag"
      />
      <van-field
        required
        v-model="states.phone"
        clearable
        label="手机号"
        placeholder="请输入手机号"
        type="number"
        maxlength="11"
        :rules="[{ required: true, message: '请填写手机号' },
          {
            validator: (val) => val.length === 11,
            message: '请输入11位手机号'
          }
        ]"
        :error="PhoneFormatDifferent"
        :error-message="errorMessagePhoneFormat"
        @blur="validateInputsPhoneFormat"
      />
      <van-field
        required
        v-model="states.phoneSure"
        clearable
        label="确认手机号"
        placeholder="请确认手机号"
        type="number"
        maxlength="11"
        :rules="[{ required: true, message: '请确认手机号' }]"
        :error="phoneDifferent"
        :error-message="errorMessagePhone"
        @blur="validateInputsPhone"
        @paste.prevent
      />
    </div>
      <!--登录按钮-->
      <div style="margin: 16px">
        <van-button round block type="primary" native-type="submit" class="btn btn_dl">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted,getCurrentInstance } from "vue";
import headers from "../../../components/Header.vue";
import diyPicker from "@/components/Select";
import { useRoute, useRouter } from "vue-router";
// import DatePickerPopup from "../../../components/DatePickerPopup.vue";
// import { format } from "@/common/js/utils";
// import SelectPopup from "../../../components/SelectPopup.vue";
import datetimePicker from "@/components/DatePicker";
// import school from "@/components/School"
import { tipsMsg, getKey, encrypt, rsaUtil, serverPublicKey } from "../../../common/js";
// import SelectMultiple from "../../../components/SelectMultiple.vue";
import { addForm, editForm, getsubmitData } from "../../../service/form";
import { Dialog } from "vant";
import {
  // schoolOutAreaList,
  organizationTypeList,
  sgwZhuRenMajorList,
} from "@/common/js/field";
const route = useRoute();
const router = useRouter();
const { proxy } = getCurrentInstance();
const states = reactive({
  // schoolOutAreaTxt: '请选择',
  // schoolOutAreaKey: null,
  organizationTypeTxt: '请选择',
  organizationTypeKey: null,
  schoolOutSgwName: null,
  schoolOutSgwNameSure: null,
  foundTime: null,
  sgwZhuRenName: null,
  sgwZhuRenNameSure: null,
  organization: null,
  organizationSure: null,
  sgwZhuRenMajorTxt: '请选择',
  sgwZhuRenMajorKey: null,
  phone: null,
  phoneSure: null,
})
// const selectSchoolOutArea = (key, value) => {
//   states.schoolOutAreaKey = key;
//   states.schoolOutAreaTxt = value;
// };
const selectOrganizationType = (key, value) => {
  states.organizationTypeKey = key;
  states.organizationTypeTxt = value;
};
const selectSgwZhuRenMajor = (key, value) => {
  states.sgwZhuRenMajorKey = key;
  states.sgwZhuRenMajorTxt = value;
};
const handlerFoundTimeSelect = (key, value) => {
  states.foundTime = value;
  // if (key == "birthday") {
  //   state.birthdayFlag = false;
  // }
};

//输入验证：手机号格式验证
const PhoneFormatDifferent = ref(false);
const errorMessagePhoneFormat = ref('');
const validateInputsPhoneFormat = () => {
  if (states.phone.length != 11) {
    PhoneFormatDifferent.value = true;
    errorMessagePhoneFormat.value = '请输入11位手机号';
  } else {
    PhoneFormatDifferent.value = false;
    errorMessagePhoneFormat.value = '';
  }
};

//输入验证：手机号
const PhoneDifferent = ref(false);
const errorMessagePhone = ref('');
const validateInputsPhone = () => {
  // 检查两个输入字段的值是否一致
  if (states.phone !== states.phoneSure) {
    PhoneDifferent.value = true;
    errorMessagePhone.value = '两次输入不一致，请确认';
  } else {
    PhoneDifferent.value = false;
    errorMessagePhone.value = '';
  }
};

//输入验证：校外少工委组织名称
const schoolOutSgwNameDifferent = ref(false);
const errorMessageSchoolOutSgwName = ref('');
const validateInputsSchoolOutSgwNamee = () => {
  // 检查两个输入字段的值是否一致
  if (states.schoolOutSgwName !== states.schoolOutSgwNameSure) {
    schoolOutSgwNameDifferent.value = true;
    errorMessageSchoolOutSgwName.value = '两次输入不一致，请确认';
  } else {
    schoolOutSgwNameDifferent.value = false;
    errorMessageSchoolOutSgwName.value = '';
  }
};

//输入验证：少工委主任姓名
const sgwZhuRenNameDifferent = ref(false);
const errorMessageSgwZhuRenName = ref('');
const validateInputSgwZhuRenName = () => {
  // 检查两个输入字段的值是否一致
  if (states.phone !== states.phoneSure) {
    sgwZhuRenNameDifferent.value = true;
    errorMessageSgwZhuRenName.value = '两次输入不一致，请确认';
  } else {
    sgwZhuRenNameDifferent.value = false;
    errorMessageSgwZhuRenName.value = '';
  }
};


//输入验证：确认所在单位
const organizationDifferent = ref(false);
const errorMessageOrganization = ref('');
const validateInputOrganization = () => {
  // 检查两个输入字段的值是否一致
  if (states.phone !== states.phoneSure) {
    organizationDifferent.value = true;
    errorMessageOrganization.value = '两次输入不一致，请确认';
  } else {
    organizationDifferent.value = false;
    errorMessageOrganization.value = '';
  }
};

const onClickButtonSubmit = async () => {
  // if (!states.schoolOutAreaKey) {
  //   tipsMsg("提示", "请选择校外少工委所在地");
  //   return false;
  // }
  if (!states.organizationTypeKey) {
    tipsMsg("提示", "请选择组织类型");
    return false;
  }
  if (states.schoolOutSgwName !== states.schoolOutSgwNameSure)  {
    tipsMsg("提示", "两次校外少工委组织名称输入不一致");
    return false;
  }
  if (!states.foundTime) {
    tipsMsg("提示", "请选择成立时间");
    return false;
  }
  if (states.sgwZhuRenName !== states.sgwZhuRenNameSure)  {
    tipsMsg("提示", "两次少工委主任姓名输入不一致");
    return false;
  }
  if (states.organization !== states.organizationSure)  {
    tipsMsg("提示", "两次所在单位输入不一致");
    return false;
  }
  if (!states.sgwZhuRenMajorKey) {
    tipsMsg("提示", "请选择少工委主任职务");
    return false;
  }
  if (states.phone !== states.phoneSure)  {
    tipsMsg("提示", "两次手机号输入不一致");
    return false;
  }
  Dialog.confirm({
    title: "提示",
    message: "你确定要提交吗？",
  })
    .then(() => {
      proxy.$showLoading();
      add(states);
    })
    .catch(() => {
      // on cancel
    });  
};
const add = async (values) => {
  let arr = [];
  const { id, type } = route.query;
  let data = {
    formId: 39,
    list: [],
  };

  let fn = addForm;
  if (type == 1) {
    data.id = id;
    fn = editForm;
    console.log("editForm---", "editForm---");
  }

  // const whiteList = [
  //   "schoolTypeFlag",
  //   "schoolTypeTxt",
  //   "rules",
  //   "birthdayFlag",
  //   "counselorTimeFlag",
  //   "sdhsjFlag",
  // ];

  for (let i in values) {
    let val = values[i];
    if (i == "foundTime" && values[i] && values[i].toString().length > 10) {
      val = val / 1000;
      values[i] = val;
    }
    // if (i == "counselorTime" && values[i] && values[i].toString().length > 10) {
    //   val = val / 1000;
    //   values[i] = val;
    // }
    // if (i == "sdhsj" && values[i] && values[i].toString().length > 10) {
    //   val = val / 1000;
    //   values[i] = val;
    // }
  }

  for (const item in values) {
    let obj = {
      fieldCode: item,
      value: values[item],
    };
    // if (whiteList.indexOf(item) !== -1) {
    //   continue;
    // }
    if (values[item] !== "请选择" && (values[item] || values[item] == 0)) {
      arr.push(obj);
    }
  }
  data.list = arr;

  //随机获取AES的key
  let aesKey = getKey().toLowerCase();
  let param = {
    encryptData: encrypt(data, aesKey), //AES加密后的数据
    encrypted: rsaUtil.encrypt(aesKey, serverPublicKey), //后端RSA公钥加密后的AES的key
    // publicKey: window.jsPublicKey //前端公钥
  };

  try {
    const res = await fn(param);
    console.log("res -> ", data);
    if (res.code === 10000) {
      proxy.$closeLoading();
      Dialog.alert({
        message: "提交成功",
      }).then(() => {
        goTo();
      });
    } else {
      proxy.$closeLoading();
    }
  } catch (error) {
    proxy.$closeLoading();
    console.log("res error -> ", error);
  }
}
const goTo = () => {
  // const { id, url } = route.query;
  // if (id) {
  router.push({ path: "/info/xtj" });
  // }
};
const goBack = () => {
  router.go(-1);
};
const errors = ref(null);
const errorsMsg = ref([]);
const handleFailed = (errorInfo) => {
  errors.value = errorInfo;
  errorsMsg.value = errors.value.errors;
  if(errorsMsg.value && errorsMsg.value.length > 0){
    tipsMsg("提示", errorsMsg.value[0].message);
  }
};
onMounted(() => {
  const { type } = route.query;
  if (type == 1) {
    getInfo();
  }
});
const getInfo = async () => {
  const { id } = route.query;
  const result = await getsubmitData({ dataId: id });
  const { code, data } = result;
  console.log("data ->", data);
  if (code == 10000 && data) {
    const newObj = {};
    for (const i of data.list) {
      let val = i.value;
      // if (i.fieldCode == "schoolType") {
      //   const st = schoolTypes.filter((r) => r.key == i.value);
      //   if (st.length > 0) {
      //     state.schoolTypeTxt = st[0].value;
      //   }
      // }
      if (
        i.fieldCode == "foundTime"
      ) {
        val = val * 1000;
      }
      newObj[i.fieldCode] = val;
    }
    //   赋值
    Object.assign(states, newObj);
  }
};
</script>

<style lang="less" scoped>
// @import "../../../common/style/mixin";
.radioStyle {
  background-color: #f90;
}

.back_left {
  width: 10%;
  height: 0.883rem;
  position: absolute;
  top: 0.233rem;
  left: 0.133rem;
  z-index: 99;
}
.go_back {
  height: 0.383rem;
  padding: 0.033rem 0 0 0.333rem;
  overflow: visible;
  color: rgb(255, 255, 255);
  font-size: 28px;
  z-index: 99;
}
.custom-cell-title {
  font-weight: bold;
  font-size: 16px;
}
:deep(.van-field__control--custom) {
  display: block;
}
.radioFlex :deep(.van-field__control--custom) {
  display: flex;
}

:deep(.van-cell__value),
:deep(.van-field__control),
:deep(.van-cell__right-icon) {
  color: #ff6865;
}
:deep(.van-radio__icon .van-icon) {
  border: 0.02667rem solid #ff6865 !important;
}
:deep(.van-cell__title) {
  color: #646566;
}
:deep(.van-radio-group) {
  padding: 0.168rem 0;
}
.title {
  text-align: center;
  font-size: 17px;
  margin-top: 10px;
  .tip {
    font-size: 12px;
  }
}
</style>
